import type { BadmintonGameListItem } from '@/services/badmintonService';

export function displayTimerMs(
  game: Pick<
    BadmintonGameListItem,
    'timerStatus' | 'timerSetNumber' | 'timerElapsedMs' | 'timerStartedAt' | 'serverTime' | 'setScores'
  >,
  setNumber: number,
  clientNow: number,
  clientReceivedAt: number = clientNow
): number {
  const setRow = game.setScores.find((s) => s.setNumber === setNumber);
  const storedElapsed =
    game.timerStatus === 'running' && game.timerSetNumber === setNumber
      ? (setRow?.elapsedMs ?? game.timerElapsedMs ?? 0)
      : (setRow?.elapsedMs ?? 0);

  if (
    game.timerStatus === 'running' &&
    game.timerSetNumber === setNumber &&
    game.timerStartedAt
  ) {
    const offset = Date.parse(game.serverTime) - clientReceivedAt;
    const serverNow = clientNow + offset;
    const startedAt = Date.parse(game.timerStartedAt);
    return Math.max(0, storedElapsed + (serverNow - startedAt));
  }

  return Math.max(0, storedElapsed);
}

export function formatTimerMmSs(ms: number): string {
  const totalSec = Math.floor(Math.max(0, ms) / 1000);
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
